"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useToggleState = function useToggleState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var handleOn = function handleOn() {
    return setState(true);
  };

  var handleOff = function handleOff() {
    return setState(false);
  };

  var toggle = function toggle() {
    return setState(!state);
  };

  return {
    state: state,
    setState: setState,
    handleOn: handleOn,
    handleOff: handleOff,
    toggle: toggle
  };
};

exports.default = useToggleState;